module.exports = __webpack_public_path__ + "img/recherches_papier.6e520639.jpg";